import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { forEach } from "lodash";
import { FormControl, Group, Layout } from "@/comn/components";

export const COMN_BASE_ADD_ITM = {
    path: `${lpcoEnvs.base}`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/comn/app/ofcr-adtnl-itm`,
    ogaApi: `${process.env.REACT_APP_API_OSCI}/`,
    nodes: [
        // TODO 라벨 처리 필요
        { path: "/", label: "" },
    ],
};

export const COMN_URLS_ADD_ITM = {};

export const APIS_ADD_ITM = {
    // Additional Item Form List !== 추가 항목 양식 목록 ==!
    // getAdtnlItmByAppCdNoList: (appCdNo: any, data: any) => {
    //     return api.get(`${COMN_BASE_ADD_ITM.api}/ofcr/${appCdNo}`, {
    //         params: data,
    //     });
    // },
    // Additional Item value List !== 추가 항목 값값 목록 ==!
    getAdtnlItmValueList: (appId: any, data: any) => {
        return api.get(`${COMN_BASE_ADD_ITM.api}/${appId}`, {
            params: data,
        });
    },
    getRowComponent: (childComponents: any[]) => {
        return <Group.Row>{childComponents}</Group.Row>;
    },
    getAdtnlItmSchemas: (form: any, adtnlItmList: any[], edit: boolean = false): any[] | undefined => {
        let arrSchemas: any[] | undefined;
        if (adtnlItmList && adtnlItmList.length > 0 && form) {
            arrSchemas = [];
            let gropControlComponents: any[] = [];

            let iCnt = adtnlItmList.length;
            for (let i = 0; i < iCnt; i++) {
                const adtnlItmInfo = adtnlItmList[i];
                const inputName = adtnlItmInfo["adtnlItmCdNo"];
                const adtnlItmNm = adtnlItmInfo["adtnlItmNm"];
                const inpTpCd = adtnlItmInfo["inpTpCd"];
                const rqrdInpYn = adtnlItmInfo["rqrdInpYn"];
                const adtnlItmMaxLenVal = adtnlItmInfo["adtnlItmMaxLenVal"];
                const rngeMinValue = adtnlItmInfo["rngeMinValue"];
                const rngeMaxValue = adtnlItmInfo["rngeMaxValue"];
                const comnCd = adtnlItmInfo["comnCd"];
                const comnCdOptions = adtnlItmInfo["comnCdOptions"];
                const optColCn = adtnlItmInfo["optColCn"];
                const optColNm = adtnlItmInfo["optColNm"];
                const optTbNm = adtnlItmInfo["optTbNm"];
                const adtnlItmCn = adtnlItmInfo["adtnlItmCn"];
                const editYn = adtnlItmInfo["editYn"];
                // !== 그 화면 롤 기준 편집 가능(EDIT_YN != 'N')일 때만 편집 ==!
                const itemEdit = edit && editYn !== "N";

                let inputType = "text";
                let disabled = false;
                if (inpTpCd == "NI") {
                    inputType = "number";
                } else if (inpTpCd == "CP") {
                    inputType = "text";
                    //disabled = true;
                } else if (inpTpCd == "CS") {
                    inputType = "select";
                } else if (inpTpCd == "DI") {
                    inputType = "date";
                } else if (inpTpCd == "PP") {
                    inputType = "text";
                    //disabled = true;
                }
                // ## input schema def
                const inputSchema: any = {
                    type: inputType,
                    label: adtnlItmNm,
                    edit: itemEdit,
                    options: comnCdOptions,
                    disabled: disabled,
                    inputName: inputName,
                };
                if (inpTpCd == "CS") inputSchema["area"] = "comnCd";

                //if (inpTpCd == "CP") inputSchema["popupSize"] = "md";

                let required: boolean = false;
                if (rqrdInpYn == "Y") required = true;

                if (itemEdit) inputSchema["required"] = required;

                if (adtnlItmMaxLenVal && adtnlItmMaxLenVal > 0) inputSchema["maxLength"] = adtnlItmMaxLenVal;

                // Range check for numeric input !== 숫자 입력(NI) 범위 검증 ==!
                if (inpTpCd == "NI" && rngeMinValue != null) inputSchema["min"] = rngeMinValue;
                if (inpTpCd == "NI" && rngeMaxValue != null) inputSchema["max"] = rngeMaxValue;

                if (inpTpCd == "CP" || inpTpCd == "CS") {
                    inputSchema["comnCd"] = comnCd;
                }
                if (inpTpCd == "PP") {
                    inputSchema["rightButton"] = {
                        icon: "search",
                        onClick: () => {
                            alert("left button Click");
                        },
                    };
                }
                if (inpTpCd == "CP") {
                    inputSchema["rightButton"] = {
                        icon: "search",
                        onClick: () => {},
                    };
                }
                arrSchemas.push(inputSchema);
                // ### Add schema
                form?.setSchema(inputName, inputSchema);
                if (inpTpCd == "CP") {
                    form?.setSchema(inputName + "_lbl", {
                        type: "text",
                        edit: true,
                        disabled: true,
                    });

                    form.setValue(inputName + "_lbl", adtnlItmInfo["adtnlItmCnLbl"]);
                }

                // ### Set Value
                form.setValue(inputName, adtnlItmCn);
            }
        }

        //form.schema = arrSchemas;
        // ### Input Component
        return arrSchemas;
    },
    getAmdAdtnlItmSchemas: (
        form: any,
        adtnlItmList: any[],
        edit: boolean = false,
        bfAdtnlItmList: any[],
        options?: { hydrateValues?: boolean }, // Initial load only !== 최초 로드 시에만 값 주입 ==!
    ): any[] | undefined => {
        const hydrateValues = options?.hydrateValues ?? false;
        // When after has no rows, treat as new amendment — pre-fill from before
        // !== 정정 후 목록 없음 = 신규 정정, 정정 전 값으로 화면 채움 ==!
        const bfList = bfAdtnlItmList ?? [];
        let list = adtnlItmList ?? [];
        if (list.length === 0 && bfList.length > 0) {
            list = bfList.map((row: any) => ({
                ...row,
                adtnlItmCn: row?.adtnlItmCn ?? "",
            }));
        }
        let arrSchemas: any[] | undefined;
        if (list.length > 0 && form) {
            arrSchemas = [];
            let gropControlComponents: any[] = [];

            let iCnt = list.length;
            for (let i = 0; i < iCnt; i++) {
                const adtnlItmInfo = list[i];
                const inputName = adtnlItmInfo["adtnlItmCdNo"];
                const adtnlItmNm = adtnlItmInfo["adtnlItmNm"];
                const inpTpCd = adtnlItmInfo["inpTpCd"];
                const rqrdInpYn = adtnlItmInfo["rqrdInpYn"];
                const adtnlItmMaxLenVal = adtnlItmInfo["adtnlItmMaxLenVal"];
                const rngeMinValue = adtnlItmInfo["rngeMinValue"];
                const rngeMaxValue = adtnlItmInfo["rngeMaxValue"];
                const comnCd = adtnlItmInfo["comnCd"];
                const comnCdOptions = adtnlItmInfo["comnCdOptions"];
                const optColCn = adtnlItmInfo["optColCn"];
                const optColNm = adtnlItmInfo["optColNm"];
                const optTbNm = adtnlItmInfo["optTbNm"];
                const adtnlItmCn = adtnlItmInfo["adtnlItmCn"];
                const editYn = adtnlItmInfo["editYn"];
                // !== 그 화면 롤 기준 편집 가능(EDIT_YN != 'N')일 때만 편집 ==!
                const itemEdit = edit && editYn !== "N";

                let inputType = "text";
                let disabled = false;
                if (inpTpCd == "NI") {
                    inputType = "number";
                } else if (inpTpCd == "CP") {
                    inputType = "text";
                    //disabled = true;
                } else if (inpTpCd == "CS") {
                    inputType = "select";
                } else if (inpTpCd == "DI") {
                    inputType = "date";
                } else if (inpTpCd == "SP") {
                    inputType = "text";
                    //disabled = true;
                }
                // ## input schema def
                const inputSchema: any = {
                    type: inputType,
                    label: adtnlItmNm,
                    edit: itemEdit,
                    options: comnCdOptions,
                    disabled: disabled,
                    inputName: inputName,
                };

                // Match the before row by item code, not by list index !== 목록 순서가 아니라 항목코드로 정정 전 행을 찾는다 ==!
                const bfAdtnlItmInfo = bfList.find((bfItem: any) => bfItem["adtnlItmCdNo"] == inputName);
                // No match = added in this amendment, different value = changed !== 짝이 없으면 이번 정정에서 추가, 값이 다르면 변경 ==!
                if (!bfAdtnlItmInfo || adtnlItmCn != bfAdtnlItmInfo["adtnlItmCn"]) {
                    inputSchema["borderColor"] = "warning";
                    inputSchema["edit"] = true;
                    if (!itemEdit) {
                        inputSchema["readOnly"] = true;
                        if (inpTpCd === "CS") {
                            inputSchema["disabled"] = true;
                        }
                    }
                }

                if (inpTpCd == "CS") inputSchema["area"] = "comnCd";

                //if (inpTpCd == "CP") inputSchema["popupSize"] = "md";

                let required: boolean = false;
                if (rqrdInpYn == "Y") required = true;

                if (itemEdit) inputSchema["required"] = required;

                if (adtnlItmMaxLenVal && adtnlItmMaxLenVal > 0) inputSchema["maxLength"] = adtnlItmMaxLenVal;

                // Range check for numeric input !== 숫자 입력(NI) 범위 검증 ==!
                if (inpTpCd == "NI" && rngeMinValue != null) inputSchema["min"] = rngeMinValue;
                if (inpTpCd == "NI" && rngeMaxValue != null) inputSchema["max"] = rngeMaxValue;

                // console.log(inputName, adtnlItmMaxLenVal);

                if (inpTpCd == "CP" || inpTpCd == "CS") {
                    inputSchema["comnCd"] = comnCd;
                }
                if (inpTpCd == "SP") {
                    inputSchema["rightButton"] = {
                        icon: "search",
                        onClick: () => {
                            alert("left button Click");
                        },
                    };
                }
                if (inpTpCd == "CP") {
                    inputSchema["rightButton"] = {
                        icon: "search",
                        onClick: () => {},
                    };
                }
                arrSchemas.push(inputSchema);

                // ### Add schema
                if(itemEdit) {
                    inputSchema["readOnly"] = false;
                    if (inpTpCd === "CS") {
                        inputSchema["disabled"] = false;
                    }
                }

                form?.setSchema(inputName, inputSchema);
                if (inpTpCd == "CP") {
                    form?.setSchema(inputName + "_lbl", {
                        type: "text",
                        edit: true,
                        disabled: true,
                    });
                    if (hydrateValues) {
                        form.setValue(inputName + "_lbl", adtnlItmInfo["adtnlItmCnLbl"]);
                    }
                }

                // Hydrate field values only on initial load !== 최초 로드 시에만 필드 값 주입 ==!
                if (hydrateValues) {
                    form.setValue(inputName, adtnlItmCn);
                }
            }
        }

        return arrSchemas;
    },
    getFormRightButtonCP: (inputName: any, comnCd: any, form: any, modal: any) => {
        return {
            icon: "search",
            onClick: () => {
                const params = { comnCd: comnCd };
                modal.openModal({
                    params,
                    url: (comnEnvs.popup as any)["comnCd"],
                    size: "md",
                    draggable: true,
                    callback: (data: any) => {
                        form.setValue(inputName, data.code);
                        form.setValue(inputName + "_lbl", data.label);
                        modal.closeModal();
                    },
                });
            },
        };
    },
    getFormRightButtonPP: (inputName: any, adtnlItmCdNo: any, form: any, modal: any) => {
        return {
            icon: "search",
            onClick: () => {
                const params = { adtnlItmCdNo: adtnlItmCdNo, ofcrYn: "Y" };
                modal.openModal({
                    params,
                    url: lpcoEnvs.frontSpfcCdPpup,
                    size: "md",
                    draggable: true,
                    callback: (data: any) => {
                        form.setValue(inputName, data.spfcCd);
                        modal.closeModal();
                    },
                });
            },
        };
    },
    getFormComponentComnCd: (schema: any, form: any, inputName: any, rightButton: any, edit: any = false) => {
        return (
            <>
                <Group.Label label={schema.label} required={schema.required} />
                <Group.Col padding={1}>
                    <Layout direction="row" gap={0}>
                        <FormControl {...form.schema[inputName]} rightButton={rightButton} edit={edit} />
                        {/* <FormControl {...form.schema[inputName + "_lbl"]} /> */}
                    </Layout>
                </Group.Col>
            </>
        );
    },
    /** Set Additional Item Value  */
    getSaveAddItmList: (data: any, addItmList: any[], itemNo: any) => {
        const arrList: any[] = [];
        if (addItmList) {
            addItmList.map((item) => {
                const tempObj: any = { ...item };
                // tempObj["adtnlItmId"] = item["adtnlItmId"];
                // tempObj["adtnlItmSrno"] = item["adtnlItmSrno"];
                // tempObj["itmNo"] = item["itmNo"];
                // tempObj["adtnlItmCdNo"] = item["adtnlItmCdNo"];
                // tempObj["adtnlItmNm"] = item["adtnlItmNm"];
                // tempObj["adtnlItmCn"] = data[item["adtnlItmCdNo"]];
                // tempObj["additmCpntCd"] = item["additmCpntCd"];
                // set value
                item.adtnlItmCn = data[item["adtnlItmCdNo"]];
                item.itmNo = itemNo || 0;
                arrList.push(item);
            });
        }
        return arrList;
    },

    // 2026-04-22 KNH: 추가 항목 값 저장 ==!
    saveAdtnlItmValueList: (appId: any, data: any) => {
        return api.post(`${COMN_BASE_ADD_ITM.api}/${appId}`, data);
    },

    checkOfcrAdtnlItmRqrd: (appId: any, prcsRoleTpCd?: any) => {
        return api.get(`${COMN_BASE_ADD_ITM.api}/${appId}/rqrd`, { params: { prcsRoleTpCd } });
    },
};

export const SF_APP_RGST_ADD_ITM: TFormSchema = {
    id: "form_app_rgst_add_itm",
    schema: {},
};

export const SF_APP_DTL_ADD_ITM: TFormSchema = {
    id: "form_app_dtl_add_itm",
    schema: {},
};
